/* LUMEYE — 商品页「多少人点赞」按钮
 * 数字 = 服务端基数(按商品稳定伪随机) + 真实点击累计；同一访客只计一次(localStorage)。 */
(function () {
  "use strict";

  var API = "https://likes.lumeye.com/api/likes";
  var LS_KEY = "lumeye_liked_";

  function formatCount(n) {
    var num = Number(n);
    if (!isFinite(num)) return "";
    var text;
    try {
      text = num.toLocaleString("en-US");
    } catch (e) {
      text = String(num);
    }
    return text + (num === 1 ? " like" : " likes");
  }

  function readLiked(id) {
    try {
      return window.localStorage.getItem(LS_KEY + id) === "1";
    } catch (e) {
      return false;
    }
  }

  function writeLiked(id) {
    try {
      window.localStorage.setItem(LS_KEY + id, "1");
    } catch (e) {}
  }

  function init(btn) {
    if (!btn || btn.dataset.lumeyeLikeInit === "1") return;
    var id = btn.getAttribute("data-product-id");
    if (!id) return;
    btn.dataset.lumeyeLikeInit = "1";

    var textEl = btn.querySelector("[data-lumeye-like-text]");
    var count = null;
    var liked = readLiked(id);

    function paint() {
      if (count !== null && textEl) textEl.textContent = formatCount(count);
      if (liked) {
        btn.classList.add("is-liked");
        btn.setAttribute("aria-pressed", "true");
        btn.setAttribute("aria-label", "Liked");
      }
    }

    fetch(API + "?product=" + encodeURIComponent(id), { headers: { Accept: "application/json" } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (data && typeof data.count === "number") {
          count = data.count;
          paint();
        }
      })
      .catch(function () {});

    btn.addEventListener("click", function () {
      if (liked) return;
      liked = true;
      if (count !== null) count += 1;
      paint();
      writeLiked(id);
      fetch(API, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ product: id })
      })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (data && typeof data.count === "number") {
            count = data.count;
            paint();
          }
        })
        .catch(function () {});
    });

    paint();
  }

  function boot() {
    var nodes = document.querySelectorAll("[data-lumeye-like]");
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
